import { breakpoints, colors, font, spacing } from '@chegg-ui/theme'
import { Typography } from '@chegg-ui/typography'
import styled from 'styled-components'

export const HeadingsContainer = styled.div`
  text-align: center;
  margin-bottom: ${spacing.px32};

  @media only screen and (min-width: ${breakpoints.md.min}) {
    margin-bottom: ${spacing.px40};
  }
  @media only screen and (min-width: ${breakpoints.lg.min}) {
    margin-bottom: ${spacing.px48};
  }
`

export const PrimaryHeading = styled(Typography).attrs({
  variant: 'h1',
  variantType: 'bold',
})`
  color: ${colors.orange800};
  font-size: ${font.size.px30};
  margin: 0 ${spacing.px64};

  @media only screen and (min-width: ${breakpoints.xl.min}) {
    font-size: ${font.size.px52};
    margin: 0;
  }
`

export const SecondaryHeading = styled(Typography).attrs({
  variant: 'h3',
  variantType: 'bold',
})`
  font-size: ${font.size.px20};
  margin-top: ${spacing.px12};
  color: ${colors.grey900};

  @media only screen and (min-width: ${breakpoints.xl.min}) {
    font-size: ${font.size.px30};
    margin-top: ${spacing.px24};
  }
`
